import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@ndd/ui";
import { Info } from "lucide-react";
import { ILLUSTRATIVE_NOTE } from "../../../lib/metrics-display";
import { METRIC_SOURCE_LABELS, type MetricSource } from "../../../../../shared/metrics";

export function FunnelInfoPopover({ source }: { source: MetricSource }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="About the session drop-off funnel"
          className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-subtle hover:text-foreground"
        >
          <Info className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 text-sm">
        <p className="font-semibold text-foreground">Session drop-off</p>
        <p className="mt-1 text-muted-strong">
          Of the patients whose first visit fell in the cohort window, how many came
          back for a second session, a third, and so on. Each bar is a share of first
          visits; the line between two bars is the share lost between them, next to the
          target for that step, and its dot shows whether that step meets, is watching,
          or is below the target.
        </p>
        <p className="mt-2 text-muted-strong">
          The hatched part of Session 3 is patients whose Medicare coverage ends after
          three sessions. They are left out of every later step, so those drop-offs
          compare against the non-Medicare group.
        </p>
        <p className="mt-2 text-muted-strong">
          Targets depend on how long the RD has been here; the switch previews the other
          band without changing the counts.
        </p>
        <p className="mt-3 text-xs text-muted-foreground">
          {source === "fake" ? ILLUSTRATIVE_NOTE : METRIC_SOURCE_LABELS[source]}
        </p>
      </PopoverContent>
    </Popover>
  );
}
